import styled from 'styled-components';
import COLORS from '../../../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../../../common/styles/fontStyles';
import DEVICES from '../../../../common/styles/devices';

export const CrossSellingBannerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${COLORS.lightShadedGrey};
  align-items: center;
  height: 167px;
  .carousel-root {
    display: flex;
    align-items: center;
    height: 100% !important;
    .carousel-slider {
      display: flex;
      height: 100%;
      align-items: center;
      .dot {
        width: 16px;
        height: 2px;
        border-radius: 4px;
        background-color: ${COLORS.borderGrey};
        box-shadow: none;
        outline: none;
        opacity: 1;
      }
      .dot.selected {
        background-color: ${COLORS.brandPrimary} !important;
      }
    }
  }

  .information-card {
    cursor: pointer;
    background-color: ${COLORS.white};
    width: 450px;
    padding: 24px 16px;
    display: grid;
    grid-template-columns: 2fr 10fr 1fr;
    align-items: center;
    gap: 8px;
    border: 1px solid ${COLORS.borderGrey};
    border-radius: 5px;
    .text-container {
      display: flex;
      flex-direction: column;

      .__title {
        font-size: 16px;
        font-family: ${FONT_FAMILY.hellix.bold};
        line-height: 26px;
      }
      .__description {
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
  @media ${DEVICES.mobileXL} {
    padding: 0 16px;
    .information-card {
      width: 100%;
    }
  }
`;

export const NFCrossSellingFormContainer = styled.div`
  display: flex;
  width: 100%;
  padding-top: 52px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .top-bar-container {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 50fr;
    padding: 0 80px;
    margin-bottom: 36px;
    .back-button {
      cursor: pointer;
    }
    .top-bar-tabs {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .tabs-container {
        display: flex;
        gap: 16px;
        .active {
          color: ${COLORS.brandPrimary};
          font-family: ${FONT_FAMILY.hellix.bold};
          border-bottom: 2px solid ${COLORS.brandPrimary};
        }
        .tab {
          font-size: 16px;
          line-height: 24px;
          cursor: pointer;
        }
      }
    }
  }

  .form-ui-container {
    width: 100%;
    display: block;
    padding: 0 0 0 80px;
    .back-button {
      cursor: pointer;
    }

    .nf-cross-sell-view {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-left: -2rem;
      .form-container {
        gap: 24px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding: 0 16px 16px;
        width: 450px;
        .currency-field-container {
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: space-between;
          padding: 8px 16px;

          border-radius: 8px;
          border: 1px solid ${COLORS.borderGrey};
          .amount-info-container {
            display: flex;
            width: 100%;
            flex-direction: column;
            justify-content: center;
            .forex-text {
              color: ${COLORS.textLightGrey};
              font-size: 16px;
              line-height: 22px;
            }
            .currencyField {
              @extend .currency-field;
              .render-text-field {
                grid-row: 1 / span 1;
                grid-column: 1 / span 1;
                width: 200px !important;
                min-height: 50px;
                margin: initial;
                display: flex;
                align-items: center;
                .input-error-wrapper {
                  padding-bottom: 10%;
                  .ui.input {
                    width: 100%;
                    input {
                      width: 100%;
                      padding: 0 !important;
                      border: none;
                      color: ${COLORS.black};
                      caret-color: ${COLORS.brandPrimary};
                      font-family: ${FONT_FAMILY.hellix.regular};
                      letter-spacing: 1.4px;
                      font-size: 24px;
                      font-style: normal;
                      font-weight: 400;
                    }
                  }
                }
                .error-msg {
                  top: auto;
                }
              }
            }
          }

          .dropdown-container {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            .currency-field-dropdown-container {
              width: 40% !important;
            }
            .dropdown-component {
              margin: 0;
              .input-error-wrapper {
                input {
                  caret-color: ${COLORS.brandPrimary};
                  margin: 8px 0px 0px 8px;
                }

                .ui {
                  width: 30px;
                }
                .ui.fluid.search.selection.dropdown {
                  width: 70px;

                  .dropdown.icon {
                    right: 15% !important;
                    @media ${DEVICES.mobileL} {
                      right: 10%;
                    }
                    top: 20px;
                    padding: 0;
                  }
                }
                .ui.active.visible.selection.dropdown {
                  .icon {
                    right: 15% !important;
                    top: 20px;
                    padding: 0;
                  }
                }
                .visible.menu.transition {
                  width: 132px;
                  left: -36px;
                  .item {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                  }
                }
                .ui.dropdown {
                  border: none !important;
                  padding: 0px;
                  height: 35px;

                  input.search {
                    padding: 0px !important;
                  }
                  .text {
                    font-family: ${FONT_FAMILY.hellix.regular};
                    font-style: normal;
                    color: ${COLORS.black};
                    padding-top: 0px;
                    width: 60px;
                    font-size: 24px;
                    font-weight: 400;
                  }
                }
              }
            }
          }
        }
        .MuiFormControl-root {
          margin: 0 !important;
        }
        [class*='makeStyles-formControl'] {
          max-width: none !important;
          margin: 0 !important;
        }
        [id*='container'] {
          width: 100% !important;
        }
        .text-input-field {
          width: 100% !important;
        }

        .input-error-wrapper {
          width: 100%;
        }

        .header-container {
          gap: 24px;
          flex-direction: column;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          margin-bottom: 24px;
          .__title {
            font-size: 40px;
            font-family: ${FONT_FAMILY.hellix.bold};
            text-align: center;
            line-height: 48px;
          }
          .__description {
            text-align: center;
            font-size: 18px;
            line-height: 28px;
          }
        }
      }
    }
  }

  @media ${DEVICES.mobileXL} {
    .top-bar-container {
      width: 100%;
      display: flex;
      padding: 0 16px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 16px;
      .top-bar-tabs {
        justify-content: flex-start;
        align-items: flex-start;
      }
    }
    .form-ui-container {
      width: 100%;
      padding: 0;
      gap: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      .back-button {
        position: relative;
        margin-left: 16px;
      }
      .nf-cross-sell-view {
        width: 100%;
        margin-left: auto;
        .form-container {
          width: 100%;
          padding: 0 16px;
          .currency-field-container {
            justify-content: flex-start;

            .dropdown-container {
              position: relative;
              right: 8px;
              .dropdown-component {
                .input-error-wrapper {
                  .ui.fluid.search.selection.dropdown {
                    width: 75px;
                  }
                  .visible.menu.transition {
                    left: -12px;
                    width: 100px;
                  }
                }
              }
            }

            .common-dropdown-wrapper .ui.dropdown.selection .menu .item {
              display: flex;
              width: fit-content;
              justify-content: flex-start;
              align-items: center;
              padding: 4px;
              img {
                width: 24px;
                height: 24px;
              }
              span {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }

  @media ${DEVICES.mobileM} {
    .nf-cross-sell-view {
      width: 100%;
      .form-container {
        width: 100%;
        padding: 0 16px;
        .currency-field-container {
          justify-content: flex-start;

          .dropdown-container {
            position: relative;
            right: 24px;
            .dropdown-component {
              .input-error-wrapper {
                .ui.fluid.search.selection.dropdown {
                  width: 75px;
                }
                .visible.menu.transition {
                  width: 90px;
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const PropositionContainer = styled.div`
  width: 700px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  .props-info-container {
    width: 100%;
    display: flex;
    gap: 24px;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .graphic-container {
      display: flex;
      width: 100%;
      gap: 24px;
      flex-direction: column;
      .__heading {
        font-size: 40px;
        line-height: 48px;
        font-family: ${FONT_FAMILY.hellix.bold};
        text-align: center;
      }
      .__sub-heading {
        text-align: center;
        line-height: 28px;
        font-size: 18px;
      }
      .cards-container {
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        .card {
          gap: 4px;
          height: 175px;
          width: 210px;
          flex-direction: column;
          display: flex;
          justify-content: flex-start;
          align-items: start;
          padding: 16px;
          border-radius: 10px;
          box-shadow: 0px 10px 20px 0px ${COLORS.blackShadow};

          border: 1px solid ${COLORS.borderGrey};
          .__card-title {
            font-size: 16px;
            line-height: 22px;
            font-family: ${FONT_FAMILY.hellix.bold};
          }
          .__card-description {
            line-height: 20px;
            font-size: 14px;
          }
          .__card-icon {
            height: 32px;
            width: 32px;
          }
        }
      }
    }
    .help-text {
      text-align: center;
      margin-bottom: 24px;
      font-size: 12px;
      line-height: 14px;
      .help-center-link {
        color: ${COLORS.darkBlue};
        font-family: ${FONT_FAMILY.hellix.bold};
      }
    }
  }
  @media ${DEVICES.mobileXL} {
    width: 100%;
    padding: 0 16px;
    .cards-container {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 24px;
    }
  }
`;

export const CrossSellingSuccessContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  .container {
    width: 418px;
    padding-top: 52px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 24px;
    .success-icon {
      width: 64px;
      width: 64px;
    }
    .__header {
      font-size: 28px;
      line-height: 38px;
      text-align: center;
      font-family: ${FONT_FAMILY.hellix.bold};
    }
    .__sub-header {
      text-align: center;
      font-size: 16px;
      line-height: 22px;
      color: ${COLORS.textGrey};
    }
  }

  @media ${DEVICES.mobileXL} {
    .container {
      padding: 16px;
      width: 100%;
    }
  }
`;
